import { Component, OnInit, PLATFORM_ID, Inject, Input, OnDestroy, Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FiltersService } from 'src/app/services/filters/filters.service';
import { Subscription } from 'rxjs';
import { StoresService } from 'src/app/services/stores/stores.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { isPlatformBrowser } from '@angular/common';
import { DescVariantsPipe } from 'src/app/pipes/desc-variants.pipe';

@Component({
    selector: 'app-filter-sidebar',
    templateUrl: './filters-sidebar.component.html',
    styleUrls: ['./filters-sidebar.component.css']
})
export class FilterSidebarComponent implements OnInit, OnDestroy {
  @Input() categories:any[]= []
  @Input() currentCategory:any
  @Input() currentSubCategory:any
  @Input() order:string = ''
  @Input() sort:string = ''
  @Input() page:number = 1
  id_store_current:string = ''

  showSort:boolean = false




  
  subCat:boolean = false


  filtersList:any[] = []
  filtersSelected:any[] = []
  categoriesSelected:any[] = []


  searchText:string = ''
  // order:string = 'name'
  // sort:string = 'asc'
  order_options:any = [
    { name: 'Nombre', type:'name', sort:'asc'},
    { name: 'Menor Precio',type:'price',sort:'asc'},
    { name: 'Mayor Precio',type:'price', sort:'desc'},
  ]
  filterPrice:any = {
    min:0,
    max:null
  }

  showCategory:boolean = true
  subCtgShow:string = ''

  @Output() productsEmmit: EventEmitter<any> = new EventEmitter()
  @Output() pageEmmit: EventEmitter<any> = new EventEmitter()



  private subscriptions: Array<Subscription> = [];
  constructor(
    @Inject(PLATFORM_ID) private platformID,
    private router: Router,
    private stores: StoresService,
    private filtersService: FiltersService,
    private productService: ProductsService,
    private spinner: NgxSpinnerService,
  ) { 
    this.getId()
  }

  ngOnInit(): void {
    // if(this.currentCategory.slug != 'todos'){
      if(this.currentSubCategory){
        this.categoriesSelected.push(this.currentSubCategory)
      }else{
        this.categoriesSelected.push(this.currentCategory)
      }
    // }
  }


  selectCtgShow(ctg){
    if(this.subCtgShow == ctg.id){
      this.subCtgShow = ''
    }
    else{
      this.subCtgShow = ctg.id
    }
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  // change(event){
  //   let pos = Number(event.target.value)
  //   this.order = this.order_options[pos].type
  //   this.sort = this.order_options[pos].sort
  // }

  setMinMaxInput(type,event){
    if(type == 'min'){
      this.filterPrice.min = Number(event.target.value)
    }else{
      this.filterPrice.max = Number(event.target.value)
    }

  }


  getId(){
    this.subscriptions.push(
      this.stores.getStoreId()
      .subscribe(async id => {
        if(id !== null && id !== "null"){
          this.id_store_current = id
          this.getFilters()
        }
      })
    )
  }

  getFilters(){
    this.filtersService.getList(this.id_store_current)
      .then(res => {
        this.filtersList = res.data.map(item=>{
          item.open = true

          let filtro = {
            id: item.id,
            id_filter: item.id,
            name: item.name,
            slug: item.slug,
            options:item.options,
            open:true
          }
          return filtro
        }).filter(filter=>filter.options.length > 0)
      })
      .catch(err => {
        console.log(err)
      })
    }

  addFilter(event,filt,option){    
    if( this.filtersSelected.length > 0){
      this.filtersSelected = this.filtersSelected.map(item=> {
        if(item.id == filt.id){
          if(event.target.checked){
            item.option.push(option)
          }else{
            item.option = item.option.filter(opt=> opt.id_number != option.id_number)
          }
        }
        return item
      })
    }else{
      let filter = {
        id: filt.id,
        option: [option]
      }
      this.filtersSelected.push(filter)
    }
  }

  addCategory(event,category){
  
    if(event.target.checked){
      this.categoriesSelected.push(category)
    }else{
      this.categoriesSelected = this.categoriesSelected.filter(item=> item.id != category.id)
    }
  }


  applyFilters(){

    let categories = []
    let subcategories = []
    
    this.categoriesSelected.filter(item => Object.keys(item).length > 0).map(item=> {
      if(item.id_category == null ){
        categories.push(item.id)
      }else{
        if(!item.slug.includes('diffuser')){
          subcategories.push(item.id)
        }
      }
    })
    let filters = []
    this.filtersSelected.map(item=> {
        item.option.map(opt=> filters.push({id_filter:opt.id_filter,id_option:opt.id_number})) 
    })
    let data = {
      categories,
      subcategories,
      filters,
      search:this.searchText,
      order:this.order,
      sort: this.sort,
      price: this.filterPrice
    }

    this.getFullListProductFilter(data)
  }


  isCollection(category){
    let keyWord = 'collection'
    return category.indexOf(keyWord) !== -1
  }

  checkCategories(products, categories) {
    const matchingProducts = [];

    products.forEach(product => {
      const variants = product.variants;
  
      for (let variant of variants) {
        let diffuserCategories = variant.categories.filter(cat => cat.category.slug.includes("diffuser"));
        if (diffuserCategories.length > 1) {
          // Si hay más de una categoría con "diffuser" en el slug, evitar hacer match entre ellas mismas
          matchingProducts.push(product);
          break;
        } else if (diffuserCategories.length === 1) {
          // Verificar si hay al menos otra categoría que coincida con el array `categories`
          const remainingCategories = categories.filter(cat => cat !== diffuserCategories[0].id_category);
          const categoryIdsInProduct = variant.categories.map(cat => cat.id_category);
          
          const atLeastOneCategoryExists = remainingCategories.some(cat => categoryIdsInProduct.includes(cat));
  
          if (atLeastOneCategoryExists) {
            matchingProducts.push(product);
            break;
          }
        }
      }
    });
  
    return matchingProducts;
  }

  getCtgs(categories, products){
    let categoriesMatch = []
    products.forEach(product=>{
      const variants = product.variants;
      variants.map(variant => {
        variant.categories.map(cat => {
          let ctg = categories.find(item=> item === cat.category?.id)
          if(ctg != undefined && categoriesMatch.find(item=> item.id_category == cat.id_category) == undefined){
            categoriesMatch.push(cat)
          }
        });

      })
        
    })
    return categoriesMatch
  }



  getProductsFiltered(products) {
    let categoriesSelecteds = this.categoriesSelected.filter(cat=>cat.id != undefined)
    if(categoriesSelecteds.some(cat => cat.slug?.includes("diffuser"))){
      let ctgDiff = categoriesSelecteds.find(ctg => ctg.slug.includes("diffuser"))
      let data = {
        categories:[],
        subcategories: [ctgDiff.id],
        filters: [],
        search:'',
        order:this.order,
        sort: this.sort,
        price: this.filterPrice
      }
      this.productService.getFullListProductFilter(this.id_store_current, data, 1)
      .then(res => {
        let diffusersProducts = res.data.data.filter(item => item.variants.length > 0)
        //-> se filtran dichos productos que tengan al menos una subcategoria de las seleccionadas
        let difusoresFilter = this.getFilterDiffusers(diffusersProducts)
        let productsFilter = this.getFilterProd(products)
        // se suman products + producsDifusores
        const uniqueProducts = [...productsFilter,...difusoresFilter].filter((product, index, self) =>
          index === self.findIndex((p) => p.id_number === product.id_number)
        );
        this.productsEmmit.emit([...uniqueProducts])
      })
      .catch(err => {
        console.log('err',err)
      })
     
    }
    else{
      this.productsEmmit.emit(products)
    }
  }


  getFilterProd(products){
    // Filtrar categorías seleccionadas que no tengan "diffuser" en el slug
    const validCategories = this.categoriesSelected.filter(cat => cat.id !== undefined)
      .filter(category => !category.slug.includes("diffuser"))
      .map(category => ({
        slug: category.slug,
        isSubcategory: Boolean(category.id_category)
      }));

    const filteredProducts = products.filter(product => {
      const productCategories = product.variants.flatMap(variant => variant.categories || []);
      // Filtrar categorías seleccionadas que contienen "collection" en el slug
      const collectionCategories = validCategories.filter(category => category.slug.includes('collection'));
      const collectionSlugs = collectionCategories.map(category => category.slug);
      
      if (collectionCategories.length > 0) {
        // Verificar que el producto tenga al menos una categoría "collection" y al menos otra categoría válida
        const hasCollection = productCategories.some(cat => collectionSlugs.includes(cat.category.slug));
        const hasOtherCategory = validCategories.some(category => 
          !category.slug.includes('collection') && productCategories.some(cat => 
            cat.category.slug.includes(category.slug)
          )
        );
        return hasCollection && hasOtherCategory;
      } else {
        // Verificar que el producto tenga al menos una categoría válida
        return validCategories.some(category => 
          productCategories.some(cat => 
            cat.category.slug.includes(category.slug)
          )
        );
      }
    });

    return filteredProducts;
  }

  getFilterDiffusers(products){
    let categoriesSelecteds = this.categoriesSelected.filter(cat=> cat.id != undefined)
    const productosFiltrados = products.filter(product => {
        const productCategories = product.variants.flatMap(variant => variant.categories);
        //verifico si existe alguna collection en las categorias
        const hasCollectionCategory = categoriesSelecteds.some(cat => cat.slug.includes("collection"));
        const hasOtherCategory = categoriesSelecteds.some(cat => 
            // cat.slug.includes("diffuser") === false && 
            //si no existe alguna collection en las categorias tengo que ignorar la condicion de que no incluya el diffuser
            (!hasCollectionCategory || (hasCollectionCategory && !cat.slug.includes("diffuser"))) &&
            productCategories.some(productCat => productCat.category.slug === cat.slug)
        );
        return hasOtherCategory;
    });
    return productosFiltrados
  }

  getFullListProductFilter(data){

    this.spinner.show()
    this.productService.getFullListProductFilter(this.id_store_current, data,this.page)
    .then(res => {
      let prods = res.data.data.filter(item => item.variants.length > 0)
      this.getProductsFiltered(prods)
      let {current_page, last_page, total} = res.data
      this.pageEmmit.emit( {current_page, last_page, total} )
      this.spinner.hide()
      
    })
    .catch(err => {
      this.spinner.hide()
    }).finally(()=>{
      if(isPlatformBrowser(this.platformID)){
        window.scrollTo(0, 0);
      }
    })
  }


}